import React from 'react';
import { Box, SxProps, Theme } from '@mui/material';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  /** Prefix of the panel's id (`<idPrefix>-tabpanel-<index>`) and of the tab it points to. */
  idPrefix?: string;
  /** Space around the content; top only by default. */
  sx?: SxProps<Theme>;
}

/** The content of one tab of an MUI `Tabs`, rendered only while that tab is selected. */
export default function TabPanel({ children, value, index, idPrefix = 'simple', sx = { pt: 3 } }: TabPanelProps) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`${idPrefix}-tabpanel-${index}`}
      aria-labelledby={`${idPrefix}-tab-${index}`}
    >
      {value === index && <Box sx={sx}>{children}</Box>}
    </div>
  );
}
